import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "@/core/components/ui/toast";
import { PAY_BREAKDOWN_PATH } from "@/payroll/pay-breakdown/routes";

// The last thing they were told was that this page would update itself when their payroll
// was ready. It does, and the update is the product: their own numbers, not a card saying
// the numbers exist with a button to go and look at them. The toast names the transition so
// the tab does not change under them silently.
export const PayrollReadyRedirect = () => {
  useEffect(() => {
    toast.success("Your payroll is ready");
  }, []);

  return <Navigate to={PAY_BREAKDOWN_PATH} replace />;
};
